import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Result } from '../ChatWidgetTroubleshootingToolResult';

export const usePageFinishedLoadingResult = (): Result => {
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);

  if (!result?.errors.pageDidNotFinishLoading) {
    return;
  }

  return {
    result: 'error',
    description:
      'Website did not complete loading in 30 seconds; results may be unreliable',
    infoTooltip: (
      <>
        <p>
          The diagnostic tool was unable to complete its analysis because the
          website did not finish loading in 30 seconds.
        </p>
        <p>
          This may be due to a slow internet connection, or a problem with the
          website itself. Please try again later, or contact your website
          administrator for help.
        </p>
      </>
    ),
  };
};
